import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LandingPage from "./pages/LandingPage";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import AppleReview from "./pages/AppleReview";

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<LandingPage />} />
                    <Route path="/privacy" element={<PrivacyPolicy />} />
                    <Route path="/privacidade" element={<PrivacyPolicy />} />
                    <Route path="/apple-review" element={<AppleReview />} />
                </Routes>
            </BrowserRouter>
        </div>
    );
}

export default App;
